var loadScript = function(src){
	var tag = document.createElement('script');
	tag.src = src;
	var firstScriptTag = document.getElementsByTagName('script')[0];
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
};

module.exports = loadScript;
